import { defineComponent as _defineComponent } from 'vue'
import { vModelDynamic as _vModelDynamic, withKeys as _withKeys, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative" }
const _hoisted_2 = ["type", "disabled", "autocomplete"]
const _hoisted_3 = {
  key: 0,
  class: "text-xs text-error-500 mt-0.5 ml-1"
}

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppInput',
  props: {
    modelValue: {},
    label: {},
    type: {},
    disabled: { type: Boolean },
    error: {},
    autocomplete: {}
  },
  emits: ["update:modelValue", "submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const uid = `input-${Math.random().toString(36).substring(6)}`;

const inputValue = computed({
    get: () => props.modelValue,
    set: (val: string) => emit('update:modelValue', val),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      id: uid,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
      type: __props.type,
      disabled: __props.disabled,
      autocomplete: __props.autocomplete,
      placeholder: " ",
      class: _normalizeClass(["app-input block w-full box-border outline-none rounded pt-6 pb-1 px-5 text-normal", __props.disabled ? 'bg-white text-gray-400 cursor-default' : 'bg-gray-100']),
      onKeydown: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('submit')), ["enter"]))
    }, null, 42, _hoisted_2), [
      [_vModelDynamic, inputValue.value]
    ]),
    _createElementVNode("label", {
      for: uid,
      class: _normalizeClass(["app-input-label text-gray-400 absolute left-5 top-4 transition-all text-normal truncate pointer-events-none", __props.disabled ? 'opacity-60' : ''])
    }, _toDisplayString(__props.label), 3),
    (__props.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.error), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})